// extracted by mini-css-extract-plugin
export default {"container":"ComboboxCoso_container__39wpu","school":"ComboboxCoso_school__j1ypw","logo":"ComboboxCoso_logo__uQec6","name":"ComboboxCoso_name__uPEg8"};